// removed by extract-text-webpack-plugin
module.exports = {"cont":"Carousel__cont___3FTId","img":"Carousel__img___1fnUH","dots":"Carousel__dots___OUlI5","screen":"Carousel__screen___2N_tQ","body":"Carousel__body___mvP5A","nextArrow":"Carousel__nextArrow___1Sc-D","prevArrow":"Carousel__prevArrow___2VBXQ"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/Carousel/Carousel.css
// module id = 739
// module chunks = 0